import React from "react";
import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreHotelsComponent } from "@b2bportal/core-types";
import { MealPlanKind } from "@b2bportal/lodging-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import { CheckboxGroup } from "@tenant/ui";
import defaultStyles from "./MealPlanFilter.module.scss";

export type MealPlanFilterProps = {
  selectedValues: MealPlanKind[];
  onChange: (values: MealPlanKind[]) => void;
};

export const MealPlanFilter = ({
  selectedValues,
  onChange,
}: MealPlanFilterProps) => {
  const styles = useHotelsStyles(
    CoreHotelsComponent.MealPlanFilter,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(styles, CoreHotelsComponent.MealPlanFilter);

  const { t } = useI18nContext();

  const allMealPlanTypes = [MealPlanKind.Breakfast, MealPlanKind.AllInclusive];

  const mealPlanTypeToTitle: {
    [key in MealPlanKind]: string;
  } = {
    Breakfast: t(
      "core-hotels.availabilityPage.filters.mealPlan.kind.breakfast"
    ),
    AllInclusive: t(
      "core-hotels.availabilityPage.filters.mealPlan.kind.allInclusive"
    ),
    BreakfastFor1: t(
      "core-hotels.availabilityPage.filters.mealPlan.kind.breakfastFor1"
    ),
    BreakfastFor2: t(
      "core-hotels.availabilityPage.filters.mealPlan.kind.breakfastFor2"
    ),
    Dinner: t("core-hotels.availabilityPage.filters.mealPlan.kind.dinner"),
    FullBoard: t(
      "core-hotels.availabilityPage.filters.mealPlan.kind.fullBoard"
    ),
    HalfBoard: t(
      "core-hotels.availabilityPage.filters.mealPlan.kind.halfBoard"
    ),
    Lunch: t("core-hotels.availabilityPage.filters.mealPlan.kind.lunch"),
    RoomOnly: t("core-hotels.availabilityPage.filters.mealPlan.kind.roomOnly"),
  };

  const options = allMealPlanTypes.map((mealPlanType) => ({
    label: mealPlanTypeToTitle[mealPlanType],
    value: mealPlanType,
  }));

  return (
    <div className={block}>
      <CheckboxGroup
        options={options}
        checkedOptions={selectedValues}
        onOptionsChange={onChange}
      />
    </div>
  );
};
